module.exports = __webpack_public_path__ + "static/logo-boldare-products.f9fc0977.svg";